import { proxy, subscribe, useSnapshot } from 'valtio'

const localStorageId = 'routemanager/v1/atoms/storageIndicatorPreferences'

type PlanType = 'operations' | 'simulation'

interface StoragePreferences {
  hideStorageLimitAlert: {
    operations: boolean
    simulation: boolean
  }
}

const localStorageValue = localStorage.getItem(localStorageId)
const defaultValue: StoragePreferences = {
  hideStorageLimitAlert: {
    operations: false,
    simulation: false,
  },
}

const storedValue: StoragePreferences = localStorageValue
  ? JSON.parse(localStorageValue)
  : defaultValue

export const storageIndicatorPreferencesAtom = proxy<StoragePreferences>(storedValue)

export function setHideStorageLimitAlert(planType: PlanType, value: boolean) {
  storageIndicatorPreferencesAtom.hideStorageLimitAlert[planType] = value
}

export function getHideStorageLimitAlert(planType: PlanType): boolean {
  return storageIndicatorPreferencesAtom.hideStorageLimitAlert[planType]
}

subscribe(storageIndicatorPreferencesAtom, () => {
  localStorage.setItem(localStorageId, JSON.stringify(storageIndicatorPreferencesAtom))
})

export const useStorageIndicatorPreferences = (planType: PlanType) => {
  const snapshot = useSnapshot(storageIndicatorPreferencesAtom)
  return [
    snapshot.hideStorageLimitAlert[planType],
    (value: boolean) => setHideStorageLimitAlert(planType, value),
  ] as const
}
